module.exports = __webpack_public_path__ + "img/image10.9aae8d83.svg";